import PropTypes from 'prop-types';

const ExclamationTriangle = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M8.276 2.932c.774-1.315 2.675-1.315 3.449 0l6.502 11.054c.785 1.333-.176 3.015-1.723 3.015H3.497c-1.547 0-2.508-1.682-1.724-3.015zM10 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0-8a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1"
            fill={color}
        />
    </svg>
);

export default ExclamationTriangle;

ExclamationTriangle.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
